import numeral from "numeral";
import isFinite from "lodash/isFinite";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import round from "lodash/round";
import replace from "lodash/replace";

const nonNumericalRegex = /[^0-9.]+/gm;
const percentRegEx = /^[-]?[0-9.]+%$/;

const hasPercentSign = v => v && percentRegEx.test(v);

const convertInt = v => {
    const numericValue = parseInt(v, 10);
    return isFinite(numericValue) ? numericValue : v;
};

const convertFloat = v => {
    const numericValue = parseFloat(v);
    return isFinite(numericValue) ? numericValue : v;
};

const convertNumber = v => {
    const numericValue = numeral(v).value();
    const useEnteredValue = isEmpty(v) || (!isFinite(v) && numericValue === 0);
    return useEnteredValue ? v : numericValue;
};

const convertNumberFixed = v => {
    const numericValue = numeral(v).value();
    const useEnteredValue = isEmpty(v) || (!isFinite(v) && (numericValue === 0 || isNil(numericValue)));
    return useEnteredValue ? v : Number(numericValue.toFixed(2));
};

const convertPercent = v => {
    const percentNumber = replace(v, "%", "");
    return convertNumber(percentNumber);
};

const convertPercentWithSign = v => {
    return hasPercentSign(v) ? convertPercent(v) : v;
};

const convertRate = v => {
    if (!v) {
        return "";
    } else if (nonNumericalRegex.test(v)) {
        return v;
    }
    const convertedValue = convertPercent(v);
    return isFinite(convertedValue) ? round(convertedValue, 3) : convertedValue;
};

const convertRateWithPercentSign = v => {
    if (!v) {
        return "";
    } else if (nonNumericalRegex.test(v) && !hasPercentSign(v)) {
        return v;
    }
    const convertedValue = convertPercentWithSign(v);
    return isFinite(convertedValue) ? round(convertedValue, 3) : convertedValue;
};

export default {
    out: {
        convertInt,
        convertFloat,
        convertNumber,
        convertNumberFixed,
        convertPercent,
        convertPercentWithSign,
        convertRate,
        convertRateWithPercentSign
    }
};